import styles from './styles.less';
import Radium from 'radium';
import ClipList from 'show-page/components/clip-list';
import { observer, propTypes } from 'mobx-react';


function LatestClips(props) {
    return (
        <div className={ cx(styles.root, props.className) }>
            <h5 className={ styles.title }>{ props.title }</h5>
            <ClipList
                clipClassName={ styles.clip }
                clips={ props.clips.slice(0, 5) }
                highlightColor={ props.highlightColor }
                rolloverTextColor={ props.rolloverTextColor }
                onVideoSelect={ props.onVideoSelect }
                selectedVideoId={ props.selectedVideoId }>
                <div className={ styles.moreClips }>
                    <div
                        className={ styles.moreClipsCard }
                        onClick={ props.onMoreClipsSelect }
                        style={[
                            !Modernizr.touch && {
                                ':hover': {
                                    backgroundColor: props.highlightColor,
                                    color: props.rolloverTextColor
                                }
                            }
                        ]}>
                        <span className={ styles.moreClipsLabel }>More Clips</span>
                    </div>
                </div>
            </ClipList>
        </div>
    );
}

LatestClips.propTypes = {
    clips: propTypes.arrayOrObservableArray.isRequired,
    highlightColor: React.PropTypes.string,
    onMoreClipsSelect: React.PropTypes.func.isRequired,
    onVideoSelect: React.PropTypes.func.isRequired,
    rolloverTextColor: React.PropTypes.string,
    title: React.PropTypes.string.isRequired
};

LatestClips.defaultProps = {
    title: 'Latest Clips'
};


export default observer(Radium(LatestClips));



/** WEBPACK FOOTER **
 ** ./src/show-page/components/latest-clips/index.js
 **/